import allowed from '@/core/constants/allowed-roles.constant'

const index = [
  {
    name: 'learning-lens',
    path: '/culture',
    meta: {
      requiresAuth: true,
      layout: 'home',
      module: 'learning-lens',
      allowedRoutes: [...allowed.learning_lens.roles],
    },
    children: [
      {
        name: 'learning-lens-home',
        path: 'learning-lens',
        component: () =>
          import(
            '@/modules/learning-lens/containers/learning-lens.container.vue'
          ),
      },
    ],
  },
]

export default index
